import styled from '@emotion/styled'

import { mediaMax, sectionTitle, sectionSubtitle } from '@/styles/mixins'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`

export const MediaWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 65%;

  &.long {
    padding-top: 56.25%;
  }
`

export const Thumbnail = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  top: 0;
  left: 0;
  object-fit: cover;
  opacity: 1;
  transition: opacity ease-out .3s;
  cursor: ${p => p.isThumbnail ? 'pointer' : 'auto'};

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
`

export const Source = styled.video`
  position: absolute;
  z-index: 1;
  width: 99%;
  height: 99%;
  background-color: transparent;
  display: flex;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${mediaMax.xs} {
    background-color: transparent;
  }
`

export const ContentWrapper = styled.div`
  padding-top: 35px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`

export const Category = styled.span`
  ${sectionSubtitle()};
  color: ${({ theme }) => theme.colors.lightGreen};
  margin-bottom: 1.2rem;

`

export const Title = styled.p`
  ${sectionTitle()};
  font-size: 2.8rem;
  color: ${({ theme }) => theme.colors.greyText};
  margin-bottom: 1.5rem;
  ${mediaMax.xs} {
    font-size: 3rem;
    margin-bottom: 2rem;
  }
`

export const Text = styled.p`
  font-size: 1.4rem;
  line-height: 2.2rem;
  font-family: ${({ theme }) => theme.fonts.sansSerif};
  color: ${({ theme }) => theme.colors.grey};
  ${mediaMax.xs} {
    font-size: 1.6rem;
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 80;
  pointer-events: none;

  > * {
    position: relative;
    left: 2px;
  }
`
